export class Alert {
  key: string;
  type: AlertType;
  sticky: boolean; // Don't hide on Route Change

  constructor(init?: Partial<Alert>) {
    Object.assign(this, init);
  }
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning,
}
